export default function AssetsIcon() {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='40' height='40' rx='8' fill='var(--purple)' />
      <text x='50%' y='54%' dominantBaseline='middle' textAnchor='middle' fill='white' fontSize='20'>
        A
      </text>
    </svg>
  )
}
